import {get, post, postFile} from './http'

export const apiSignIn = p => post('/signIn', p);

export const apiSignUp = p => post('/signUp', p);

export const apiSignOut = p => post('/signOut', p);

export const getConsoleUserList = p => post("/consoleUser/getConsoleUserList", p);

export const forbiddenConsoleUser = p => post("/consoleUser/forbiddenConsoleUser", p);

export const enableConsoleUser = p => post("/consoleUser/enableConsoleUser", p);

export const updateUserGroup = p => post("/consoleUser/updateUserGroup", p);

export const createUser = p => post("/consoleUser/createUser", p);

export const getUserList = p => post("/user/getUserList", p);

export const forbiddenUser = p => post("/user/forbiddenUser", p);

export const enableUser = p => post("/user/enableUser", p);

export const commitNewConfig = p => postFile("/baseConfig/commitNewConfig", p);

export const commitCatCardConfig = p => postFile("/baseConfig/commitCatCardConfig", p);

export const downloadFile = p => post("/baseConfig/downloadFile", p);

export const getCatActivityList = p => post("/activity/getCatActivityList", p);

export const getCatActivityDetail = p => post("/activity/getCatActivityDetail", p);

export const saveActivitySwitch = p => post("/activity/saveActivitySwitch", p);

export const getCatPanelList = p => post("/activity/getCatPanelList", p);

export const getTaskList = p => post("/activity/getTaskList", p);

export const finishTask = p => post("/activity/finishTask", p);

export const getInventoryList = p => post("/activity/getInventoryList", p);

export const getInventoryOperateList = p => post("/activity/getInventoryOperateList", p);

export const updateInventoryNum = p => post("/activity/updateInventoryNum", p);

export const updatePauseStatus = p => post("/activity/updatePauseStatus", p);

export const getGuessInfo = p => post("/guess/getGuessInfo", p);

export const getCatGuessList = p => post("/guess/getCatGuessList", p);

export const getGuessList = p => post("/guess/getGuessList", p);

export const updateGuessPauseStatus = p => post("/guess/updateGuessPauseStatus", p);

export const saveGuessSwitch = p => post("/guess/saveGuessSwitch", p);

export const getCatList = p => post("/guess/getCatList", p);

// 首页动态
export const getMomentList = p => post("/moment/getMomentList", p);

export const getMomentDetail = p => post("/moment/getMomentDetail", p);

export const addMoment = p => post("/moment/addMoment", p);

export const editMomentDetail = p => post("/moment/editMomentDetail", p);

export const updateMomentStatus = p => post("/moment/updateMomentStatus", p);

//  upload
export const uploadPhoto = p => postFile("/upload/uploadPhoto", p);

export const uploadMedia = p => postFile("/upload/uploadMedia", p);


//  mail
export const addPresentMail = p => post("/mail/addPresentMail", p);

export const addSystemMail = p => post("/mail/addSystemMail", p);


// WEBPACK FOOTER //
// ./src/request/api.js